import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-zinc-900 py-16" aria-labelledby="garantia-titulo" data-id="element-50" data-mp="4uqdmw6js2tb">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 px-6 text-center sm:flex-row sm:text-left" data-id="element-51" data-mp="9umi0wj5pw9e">
        <ShieldCheckIcon className="h-16 w-16 shrink-0 text-amber-400" aria-hidden="true" data-id="element-52" data-mp="etpngi31u4hw" />
        <div data-id="element-53" data-mp="jt2bv79kjjml">
          <h2 id="garantia-titulo" className="font-display text-2xl uppercase text-white sm:text-3xl" data-id="element-54" data-mp="jrhfdc3p1qm3">
            7 días de garantía
          </h2>
          <p className="mt-3 text-base leading-relaxed text-zinc-300" data-id="element-55" data-mp="skcd7kqu0k1u">
            Si sentís que este material no te da al menos 3 ideas nuevas para tu próxima clase, te
            devolvemos el 100% de tu dinero. Sin preguntas.
          </p>
        </div>
      </div>
    </section>;
}